const rateCardItems = [
  // Electrical Parts
  { desc: "Non-Inverter PCB repair service", price: "₹1500" },
  { desc: "Inverter PCB servicing", price: "₹4000" },
  { desc: "LVT replacement", price: "₹1250 (Labour charge included 349)" },
  { desc: "Sensor replacement", price: "₹850 (Labour charge included 450)" },
  { desc: "Contactor unit replacement", price: "₹999 (Labour charge included 499)" },
  { desc: "Contactor (Daikin/O-General)", price: "₹1950 (Labour charged included 450)" },
  { desc: "PCB conversion with remote", price: "₹1500" },
  { desc: "Fan capacitor (2.5–10 mfd)", price: "₹699 (Labour charge included 450)" },
  { desc: "Compressor capacitor (25–60 mfd)", price: "₹850 (Labour charge included 450)" },
  { desc: "Combo capacitor replacement", price: "₹950 (Labour charge included 450)" },

  // Gas Charging
  { desc: "Gas refill service", price: "₹2500" },
  { desc: "Flair nut change", price: "₹150" },
  { desc: "Copper condenser coil (Split 1 Ton)", price: "₹4000" },
  { desc: "Copper condenser coil (Split 1.5 Ton)", price: "₹4500" },
  { desc: "Copper condenser coil (Split 2 Ton)", price: "₹5000" },
  { desc: "Copper Cooling coil (Split AC-1 TON)", price: "₹5500" },
  { desc: "Copper Cooling coil (Split AC-1.5 TON)", price: "₹6000" },
  { desc: "Copper Cooling coil (Split AC-2 TON)", price: "₹7000" },
  { desc: "Copper Cooling coil (Split AC GENERAL-MITSHUBISHI 1.5 TON)", price: "₹7000" },
  { desc: "Copper cooling coil condenser coil (Window 1 Ton)", price: "₹4500" },
  { desc: "Copper cooling coil condenser coil (Window 1.5 Ton)", price: "₹5000" },
  { desc: "Copper cooling condenser coil (Window 2 Ton)", price: "₹5500" },
  { desc: "Capillary + filter swap", price: "₹350" },
  { desc: "Compressor 0.8-1 ton", price: "₹6500" },
  { desc: "Compressor 1.5 ton", price: "₹7500" },
  { desc: "Compressor 2 ton", price: "₹9200" },
  { desc: "Compressor replaced 0.8-1 ton", price: "₹3800" },
  { desc: "Compressor replaced 1.5 ton", price: "₹4400" },
  { desc: "Compressor replaced 2 ton", price: "₹4800" },
  { desc: "Expansion valve replacement", price: "₹1200" },
  { desc: "Service valve replacement - 1/4", price: "₹400" },
  { desc: "Service valve replacement - 1/2", price: "₹400" },
  { desc: "Service valve replacement - 5/8", price: "₹500" },
  { desc: "Fuse Change in PCB", price: "₹449 (Labour charge included 299)" },
  { desc: "Cooling coil patch + anti-rust", price: "₹749" },

  // Fan Motors
  { desc: "Fan motor out door Split AC", price: "₹2100 (Labour charge included 499)" },
  { desc: "Blower motor (Split AC)", price: "₹2499 (Labour charge included 499)" },
  { desc: "Blower unit change", price: "₹1599 (Labour charge included 499)" },
  { desc: "Swing motor replacement", price: "₹899 (Labour charge included 499)" },
  { desc: "Motor bearing replacement", price: "₹1000" },
  { desc: "Fan motor (Window AC)", price: "₹2899 (Labour charge included 499)" },

  // Service & Installation
{ desc: "Copper kit 1 meter (pipe, insulation, wire)", price: "₹840" },
{ desc: "Wall stand Split AC", price: "₹650" },
{ desc: "Outdoor unit re-fit", price: "₹799" },
{ desc: "Indoor unit re-fit", price: "₹699" },
{ desc: "Fasteners (complete set)", price: "₹200" },
{ desc: "Floor stand", price: "₹500" },
{ desc: "Universal back plate", price: "₹300" },
{ desc: "Basic AC cleaning", price: "₹450" },
{ desc: "Foam jet wash service", price: "₹599" },
{ desc: "Anti-rust spray coat", price: "₹349" },
{ desc: "Drain pipe (1m)", price: "₹300 (Labour charge included 200)" },

  // Minor Repairs
  { desc: "Fix water leak -Split AC", price: "₹550 (Labour charge included 400)" },
  { desc: "Grill lock adjustment", price: "₹349 (Only Labour charge 349)" },
  { desc: "Compressor & pipe tightening", price: "₹349 (Only Labour charge 349)" },
  { desc: "Connector wire replace (1m)", price: "₹499 (Labour charge included 399)" },
  { desc: "Thimble tighten/replace", price: "₹399 (Only Labour charge 399)" },
  { desc: "Debris removal (external)", price: "₹399 (Only Labour charge 399)" },
  { desc: "Insulation refix", price: "₹399 (Only Labour charge 399)" },
  { desc: "Realign drain pipe", price: "₹399 (Only Labour charge 399)" },
  { desc: "Motor sound issue fix", price: "₹399 (Only Labour charge 399)" },
  { desc: "Blower noise repair", price: "₹399 (Only Labour charge 399)" },
  { desc: "Cabinet noise issue fix", price: "₹399 (Only Labour charge 399)" },
  { desc: "Swing flap noise issue fix", price: "₹399 (Only Labour charge 399)" },
  { desc: "Fix water leak - Window AC", price: "₹449 (Only Labour charge 449)" },
  { desc: "External Dust removal", price: "₹399 (Only Labour charge 399)" },
  
  // Other Parts
  { desc: "AC fan blade", price: "₹1199 (Labour charge included 499)" },
  { desc: "Grill Cover", price: "₹1849 (Labour charge included 349)" },
  { desc: "Swing blade replaced", price: "₹749 (Labour charge included 349)" },
  { desc: "Universal remote", price: "₹800" },
  { desc: "Water tray", price: "₹699 (Labour charge included 200)" },
  { desc: "Stabilizer repair", price: "₹1500" },
  { desc: "Sleeves (per piece)", price: "₹50" },
  { desc: "Noise issue repair", price: "₹499 (Only Labour charge 499)" },
  { desc: "Stabilizer connection", price: "₹399 (Only Labour charge 399)" }
];

rateCardItems.sort((a, b) => a.desc.toLowerCase().localeCompare(b.desc.toLowerCase()));

export default rateCardItems;
